import { isWebViewFarmi } from '@b2ag/farmi-app-appro-tools';
import { auth0ClientFactory } from '../../repository/auth0.client.factory';
import { authRepositoryFactory } from '../../repository/auth.repository.factory';
import { contexts } from '../../../contexts';
import { authService as authServiceDefault } from '../../../contexts/default';
import { authService as authServiceFarmiAppAppro } from '../../../contexts/farmi-app-appro';
import { authService as authServiceServerSide } from '../../../contexts/server-side';
// Note: Not using provide/inject for compatibility reasons with
// vue router, as we need to call the authService within the
// beforeEach guard, and injection is not available there.
let authService;
async function defaultAuthService(config) {
    const auth0Client = await auth0ClientFactory(config);
    const authRepository = authRepositoryFactory({
        auth0Client,
        auth0Config: config,
    });
    return authServiceDefault(config, authRepository);
}
export async function provideAuthService(config, context = { name: contexts.DEFAULT }) {
    // Créer une copie locale du contexte pour éviter no-param-reassign
    const contextToUse = { name: context.name };
    if (typeof window !== 'undefined' && isWebViewFarmi()) {
        contextToUse.name = contexts.FARMI_APP_APPRO;
    }
    switch (contextToUse.name) {
        case contexts.FARMI_APP_APPRO:
            authService = authServiceFarmiAppAppro();
            break;
        case contexts.SERVER_SIDE:
            authService = authServiceServerSide();
            break;
        case contexts.DEFAULT:
        default:
            authService = await defaultAuthService(config);
            break;
    }
}
export function useAuthService() {
    if (!authService) {
        throw new Error('AuthService was not initialized');
    }
    return authService;
}
//# sourceMappingURL=useAuth.js.map